import '../css/tokens.css';
import '../css/buttons.css';
import '../css/badges.css';
import '../css/cards.css';

(function ($) {
    'use strict';

    var MkUi = window.MkUi || {};

    MkUi.ajax = function (action, data, nonce, nonceKey) {
        nonceKey = nonceKey || 'nonce';
        var formData = new FormData();
        formData.append('action', action);
        formData.append(nonceKey, nonce);

        var payload = data || {};
        Object.keys(payload).forEach(function (key) {
            var value = payload[key];
            if (value !== null && typeof value === 'object') {
                value = JSON.stringify(value);
            }
            formData.append(key, value);
        });

        var url = (window.mkUiKit && window.mkUiKit.ajaxUrl) ||
                  window.ajaxurl ||
                  '/wp-admin/admin-ajax.php';

        return $.ajax({
            type: 'POST',
            url: url,
            data: formData,
            cache: false,
            dataType: 'json',
            contentType: false,
            processData: false,
        });
    };

    MkUi.escapeHtml = function (str) {
        if (str === null || str === undefined) return '';
        var div = document.createElement('div');
        div.textContent = String(str);
        return div.innerHTML;
    };

    MkUi.formatCurrency = function (amount, symbol) {
        symbol = symbol || '';
        return symbol + Number(amount).toFixed(2);
    };

    window.MkUi = MkUi;
})(jQuery);
